export default __webpack_public_path__ + "static/media/virus_sincicial_respiratorio.75af9663.pdf";